import styled from "styled-components";

export const _CloseButton = styled.span`
  position: absolute;
  top: 4px;
  right: 4px;
  z-index: 1;

  @media (max-width: 420px) {
    position: fixed;
    top: inherit;
    left: 0;
    margin-top: 10px;
    margin-left: 80%;
  }

  .glyphicon {
    color: white;
    border: 1px solid #828282;
    background-color: #828282;
    font-size: 26px;
    text-align: center;
    border-radius: 200px;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;

    &:hover {
      background-color: #969696;
      border: 1px solid #969696;
    }
  }
`;

export const _Icon = styled.span`
  cursor: pointer;
  vertical-align: middle;

  .glyphicon {
    font-size: 20px;

    &:hover {
      filter: brightness(1.2);
    }
  }
`;
